import { ExternalLink } from "lucide-react";

/**
 * Compact icon-only button placed alongside each admin table row's
 * action controls (edit / delete / regenerate). Clicking opens the
 * corresponding public detail page in a new tab so admins can eyeball
 * a live preview without hand-crafting the URL.
 *
 * Props:
 *   slug     — the record's slug (falsy → button is hidden)
 *   path     — the URL path template, e.g. "/players", "/news",
 *              "/chants", "/fan-clubs", "/fan-memories",
 *              "/transfers/news"
 *   size     — tailwind size classes for the icon (default `w-4 h-4`)
 *   testId   — optional data-testid suffix; button becomes
 *              `view-live-{testId}` for playwright targeting
 *
 * The link always points to the PRODUCTION public URL
 * (`https://allwhufc.com`) — admins want a live preview of what search
 * engines and end users actually see, not the preview environment.
 */
export default function ViewLiveLink({ slug, path, size = "w-4 h-4", testId }) {
  if (!slug || !path) return null;
  const url = `https://allwhufc.com${path}/${slug}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={`Open ${url} in a new tab`}
      className="inline-flex items-center justify-center rounded-md p-1.5 text-slate-500 hover:text-blue-600 hover:bg-blue-50 transition-colors"
      data-testid={testId ? `view-live-${testId}` : undefined}
      // The parent row usually has an onClick that triggers Edit —
      // stop propagation so a click on this icon doesn't also open the
      // edit dialog.
      onClick={(e) => e.stopPropagation()}
    >
      <ExternalLink className={size} />
    </a>
  );
}
